import { useState } from 'react'

import EmployeesTable from 'components/quoting/employees/table/EmployeesTable'
import { type QuotingEmployee } from 'utils/web_api.schemas'

type Props = {
  employees: QuotingEmployee[]
  isLoading: boolean
}

function Employees ({ employees, isLoading }: Props) {
  const [filteredStates, setFilteredStates] = useState<string[]>([])

  return (
    <EmployeesTable
      isLoading={isLoading}
      employees={employees}
      filteredStates={filteredStates}
      onStateFilterChange={(state, checked) => {
        if (checked) {
          setFilteredStates([...filteredStates, state])
        } else {
          setFilteredStates(filteredStates.filter(s => s !== state))
        }
      }}
    />
  )
}

export default Employees
